import PageHeaderWithdraw from "./PageHeaderWithdraw";
import PageHeaderAddFunds from "./PageHeaderAddFunds";
import useProfile from "hooks/useProfile";

const PageHeaderUserWallet = () => {
  const { balance } = useProfile();

  return (
    <>
      <button className="page-header__user-wallet">
        <span>$ {balance ? Number(balance).toFixed(2) : 0}</span>
        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M3.3335 5.91671V14.6667C3.3335 16.0474 4.45278 17.1667 5.8335 17.1667H16.6668V8.00004H13.3335M3.3335 5.91671C3.3335 7.0673 4.26624 8.00004 5.41683 8.00004H13.3335M3.3335 5.91671C3.3335 4.76611 4.26624 3.83337 5.41683 3.83337H13.3335V8.00004"
            stroke="currentColor" strokeWidth="1.4" strokeLinecap="square" />
          <path
            d="M12.9167 13.375C13.3539 13.375 13.7083 13.0205 13.7083 12.5833C13.7083 12.1461 13.3539 11.7916 12.9167 11.7916C12.4794 11.7916 12.125 12.1461 12.125 12.5833C12.125 13.0205 12.4794 13.375 12.9167 13.375Z"
            fill="currentColor" stroke="currentColor" strokeWidth="0.75" />
        </svg>
      </button>

      <section className="page-header__user-popup">
        <b className="page-header__user-popup-title">Balance</b>
        <nav className="page-header__user-popup-actions">
          <PageHeaderWithdraw />
          <PageHeaderAddFunds />
        </nav>
      </section>
    </>
  );
};

export default PageHeaderUserWallet;
